import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
// import PostDetails from "../components/PostDetails";
import Userdetails from '../components/Userdetails';
import Poststories from "../components/Poststories";
import Wallet from "../components/Wallet";
import CommentsTable from "../components/CommentsTable";
import CommentReplies from "../components/CommentReplies";
import Userotherdetails from "../components/Userotherdetails";
import Notificationuser from "../components/Notificationuser";
import { ApiUrl } from '../Constants/Weburl'
import Layout from "../components/Layout";


export default function UserView() {

   
    // return (
    //     <div className="layout">
    //         <Sidebar />

    //         <div className="content">
    //             <Topbar />

    //             <div className="pv-grid">
    //                 <Userdetails />
    //                  <Wallet />
                   
    //                 {/* <div className="pv-gridwallet"> */}
                       
    //                     <div className="pv-griduserother">
    //                         <Userotherdetails />
    //                         <div className="pv-gridnotification">
    //                             <Notificationuser />
    //                              <Poststories />
    //                         </div>
    //                         {/* <div style={{margin:20}}> */}

    //                     </div>

    //                      <div className="commentstablesuser">
                       
    //                     {/* <CommentReplies /> */}
    //                 </div>
    //                 </div>
    //             </div>
    //         {/* </div> */}
    //     </div>
    // );
   return (
    <div className="layout">
           <Layout>
            <div className="pv-grid">
                <div className="pv-gridtop">
                    <Userdetails />
                    <Wallet />
                </div>

                <div className="pv-griduserother">
                    <Userotherdetails />
                    <div className="pv-gridnotification">
                         <Poststories />
                        <Notificationuser />
                       
                    </div>
                </div>

                <div className="commentstablesuser">
                    {/* <CommentReplies /> */}
                </div>
            </div>
               </Layout>
        </div>
     
    
);

}